import React from "react";
import { Link } from "react-router-dom";
import "./DetailLinks.css";

const DetailLinks = () => {
  return (
    <section className="detail-links">
      <div className="detail-container">
        {/* Logo */}
        <div className="detail-logo">
          <Link to="/">
            <img
              src="/about.png"
              alt="RO Service Solution"
              className="footer-logo"
            />
          </Link>
        </div>

        {/* About */}
        <div className="detail-about">
          <h3>RO Service Solution</h3>
          <p>RO Service Solution provides expert repair, installation, and maintenance services for RO Water Purifiers, Air Conditioners, Refrigerators, Washing Machines, Microwaves, and other household appliances. Our trained technicians deliver reliable doorstep solutions across multiple cities in India.</p>
        </div>

      </div>
    </section>
  );
};

export default DetailLinks;